import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import DirectorsMessageComponent from "../components/DirectorsMessageComponent";
const DirectorsMessagePage = () => {
    return(
        <div className="main-container">
            <NavBar/>
            <DirectorsMessageComponent/>
            <Footer/>
        </div>
    )
}
export default DirectorsMessagePage